'use strict';

import * as angular from 'angular';

var app = angular.module('noc.login', []);

app.factory('AuthenticationFactory', require('./authenticationFactory'));

export default app;